<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <!-- Sección Izquierda (Título) -->
                            <div class="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                                <h6 class="mb-2 ms-2">Actualizar Incidencias de Factorial</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="d-flex flex-column flex-md-row justify-content-between mb-2">
                            <div class="col-12 col-md-10">
                                <input class="form-control" type="file" @change="handleFileUpload"
                                    accept=".xlsx, .xls" />
                            </div>
                            <div class="col-12 col-md-2 text-center">
                                <button class="btn btn-warning" @click="submitData">Cargar datos</button>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <div class="col-12 col-md-4 text-center text-md-start mb-4 mb-md-0">
                                <h6 class="mb-2 ms-2">Incidencias de Factorial</h6>
                            </div>
                            <table id="incidentsTable" class="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Incidencia</th>
                                        <th>Estatus</th>
                                        <th>Empieza</th>
                                        <th>Termina</th>
                                        <th>Notas</th>
                                        <th>Creado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Los datos se insertarán aquí -->
                                    <tr v-for="incident in incidents" :key="incident.incident_id">
                                        <td>{{ incident.name }} {{ incident.last_name }}</td>
                                        <td>{{ incident.description }}</td>
                                        <td>{{ incident.status }}</td>
                                        <td>{{ formatDate(incident.starts_on) }}</td>
                                        <td>{{ formatDate(incident.ends_on) }}</td>
                                        <td>{{ formatDate(incident.created_at) }}</td>
                                        <td>{{ incident.notes }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

import { onMounted, ref } from 'vue'
import * as XLSX from 'xlsx'

import axios from 'axios';
const token = localStorage.getItem('authToken');
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const body = ref([])

const expectedHeaders = [
    'employee_id',
    'incident_id',
    'leave_type_name',
    'status',
    'duration',
    'duration_type',
    'created_at',
    'start_on',
    'finish_on',
    'link',
    'description'
];

const handleFileUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' })

        // Validar encabezados
        const headers = Object.keys(jsonData[0] || {});
        const missingHeaders = expectedHeaders.filter(h => !headers.includes(h));

        if (missingHeaders.length > 0) {
            alert(`El archivo Excel no contiene las siguientes columnas requeridas: ${missingHeaders.join(', ')}`);
            return;
        }

        body.value = jsonData
    }

    reader.readAsArrayBuffer(file)
}

const submitData = async () => {

    if (!body.value) { return }

    try {
        const response = await axios.post(`${API_BASE_URL}/upload-factorial-incidents`, body.value, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        if (response.status === 200) {
            alert(`${response.data.msg}`)
            window.location.reload
        }
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }

}

const formatDate = (IsoDate) => {
    const date = new Date(IsoDate);
    const day = date.getDate() + 1;
    const month = date.getMonth() + 1;
    const year = date.getFullYear().toString();
    return `${day}/${month}/${year}`;
}

const incidents = ref([])

const loadIncidents = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-factorial-incidents`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        if (response.status === 200) {
           incidents.value = response.data
        }
    } catch (error) {
        console.error('Error al obtener los datos de clientes:', error);
    }
}

// Inicializa el DataTable después de obtener los datos
onMounted(async () => {
    await loadIncidents();
});

</script>